import Vue from 'vue'
import Vuex from 'vuex'

import importParcelModule from "../store/import/index.js";
Vue.use(Vuex)

export default new Vuex.Store({
  modules: initialStateModules(),
  state: {

  },
  getters: {
    
  },
  mutations: {

  },
  actions: {

  }
});
function initialStateModules() {
	return {
    importParcel: importParcelModule,
  }
};
